import { THEME } from 'components/theme'

export const PopupStyles = {
  main: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '16px 22px',
    zIndex: 1000,
    borderRadius: '8px',
    backgroundColor: THEME.brandWhite,
    maxHeight: '100vh',
    overflowY: 'auto'
  },
  noPadding: {
    padding: '0px'
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    zIndex: 1000
  }
}
